<template>
    <b-modal :title="$t('history.modal.header.Information')"
             ref="information-modal"
             size="xl"
             hide-footer>
        <form ref="form" v-if="shipmentInfo">
            <b-row>
                <b-col>
                    <b-row>
                        <b-col>
                            <informationAddress :address="shipmentInfo.receiverAddress"
                                                :title="$t('history.label.Receiver')"></informationAddress>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mt-3">
                            <informationAddress :address="shipmentInfo.senderAddress"
                                                :title="$t('history.label.Sender')"></informationAddress>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mt-3">
                            <informationAddress :address="shipmentInfo.pickupAddress"
                                                :title="$t('history.label.Pickup')"></informationAddress>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mt-3">
                            <h6 style="font-weight: bold">
                                {{ $t('history.label.Contact') }}
                            </h6>

                            <span v-if="shipmentInfo.receiverAddress.contactPerson.mails.length > 0">
                                {{ $t('history.label.Receiver') }}:
                                <a v-bind:href="
                                        `mailto:${
                                            shipmentInfo.receiverAddress.contactPerson.mails[0]
                                        }?subject=AWB ${shipment.shipmentRef}, to ${
                                            shipment.receiverName
                                        } sent ${shipment.shipDate.substring(0, 10)}, Ref.${
                                            shipment.receiversReference
                                                ? shipment.receiversReference
                                                : ''
                                        }/${
                                            shipment.sendersReference
                                                ? shipment.sendersReference
                                                : ''
                                        }&body=Tracking: ${encodeURIComponent(
                                            shipment.trackingLink
                                        )}`
                                    ">{{ shipmentInfo.receiverAddress.contactPerson.mails[0] }}</a>
                                <br />
                            </span>

                            <span v-if="shipmentInfo.creatorMail">
                                {{ $t('history.label.Sender') }}:
                                <a v-bind:href="
                                        `mailto:${shipmentInfo.creatorMail}?subject=AWB ${
                                            shipment.shipmentRef
                                        }, to ${
                                            shipment.receiverName
                                        } sent ${shipment.shipDate.substring(0, 10)}, Ref.${
                                            shipment.receiversReference
                                                ? shipment.receiversReference
                                                : ''
                                        }/${
                                            shipment.sendersReference
                                                ? shipment.sendersReference
                                                : ''
                                        }&body=Tracking: ${encodeURIComponent(
                                            shipment.trackingLink
                                        )}`
                                    ">{{ shipmentInfo.creatorMail }}</a>
                                <br />
                            </span>

                            <span v-if="isAdminOrSuperUser && shipmentInfo.transportCompanyMail">
                                {{ $t('history.label.Carrier') }}:
                                <a v-bind:href="
                                        `mailto:${shipmentInfo.transportCompanyMail}?subject=AWB ${
                                            shipment.shipmentRef
                                        }, to ${
                                            shipment.receiverName
                                        } sent ${shipment.shipDate.substring(0, 10)}, Ref.${
                                            shipment.receiversReference
                                                ? shipment.receiversReference
                                                : ''
                                        }/${
                                            shipment.sendersReference
                                                ? shipment.sendersReference
                                                : ''
                                        }&body=Tracking: ${encodeURIComponent(
                                            shipment.trackingLink
                                        )}`
                                    ">{{ shipmentInfo.transportCompanyMail }}</a>
                                <br />
                            </span>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col>
                    <b-row>
                        <b-col>
                            <informationDetails :title="$t('history.label.ShipmentDetails')"
                                                :shipment="shipment"
                                                :shipmentInfo="shipmentInfo"></informationDetails>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <informationDangerousGoods :title="$t('history.label.DangerousGoods')"
                                                       :shipment="shipment"
                                                       :shipmentInfo="shipmentInfo" />
                        </b-col>
                    </b-row>
                </b-col>

                <b-col>
                    <b-row>
                        <b-col>
                            <informationPrice :shipmentInfo="shipmentInfo"></informationPrice>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <informationDocuments :shipmentInfo="shipmentInfo"></informationDocuments>
                        </b-col>
                    </b-row>
                  <b-col>
                  </b-col>
                  <b-col class="mt-3" v-if="shipmentInfo.additionalMessage">
                    <b-form-group
                        label-cols-sm="12"
                        :label="$t('createShipment.label.AdditionalMessage')"
                        style="font-size: 16px; font-weight: bold; color: #333;"
                        label-align-sm="left"
                    >
                      <b-input-group size="sm">
                        <b-form-textarea
                            sm="3"
                            id="textarea"
                            v-model="shipmentInfo.additionalMessage"
                            placeholder="..."
                            rows="2"
                            max-rows="6"
                            readonly
                            style="font-size: 12px; font-weight: 700"
                        ></b-form-textarea>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <b-button-group>
                        <b-button size="sm" v-b-toggle.packages>
                            {{ $t('history.label.ShowPackages') }} ({{
                            shipmentInfo.listOfColli.length
                            }})
                        </b-button>

                        <b-button class="ml-2"
                                  v-if="shipmentInfo.commodities && shipmentInfo.commodities.length > 0"
                                  size="sm"
                                  v-b-toggle.commodities>
                            {{ $t('history.label.ShowCommodities') }} ({{
                            shipmentInfo.commodities.length
                            }})
                        </b-button>

                        <b-button class="ml-2"
                                  v-if="shipmentInfo.shipmentAesFilings && shipmentInfo.shipmentAesFilings.length > 0"
                                  size="sm"
                                  v-b-toggle.aes>{{ $t('history.label.ShowAES') }}</b-button>

                        <b-button class="ml-2"
                                  v-if="isAdminOrSuperUser && shipmentInfo.measures && shipmentInfo.measures.some(measure => measure.measureCode === 'S' || measure.measureCode === 'M')"
                                  size="sm"
                                  v-b-toggle.measures>
                            {{ $t('history.label.ShowMeasures') }} ({{
                            shipmentInfo.listOfColli.length
                            }})
                        </b-button>

                    </b-button-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-collapse id="packages" class="mt-2">
                        <informationColli :title="$t('history.label.Package')"
                                          :collis="shipmentInfo.listOfColli"
                                          :isQuote="shipmentInfo.bookingType === BOOKING_TYPES.QUOTE_BOOKING.toString()"></informationColli>
                    </b-collapse>
                </b-col>
            </b-row>

            <b-row v-if="shipmentInfo.commodities">
                <b-col>
                    <b-collapse id="commodities" class="mt-2">
                        <informationCommodities :title="$t('history.label.Commodities')"
                                                :commodities="shipmentInfo.commodities"></informationCommodities>
                    </b-collapse>
                </b-col>
            </b-row>

            <b-row v-if="shipmentInfo.shipmentAesFilings && shipmentInfo.shipmentAesFilings.length > 0">
                <b-col>
                    <b-collapse id="aes" class="mt-2">
                        <informationAes :shipmentAesFilings="shipmentInfo.shipmentAesFilings"
                                        :title="$t('history.label.AES')"></informationAes>
                    </b-collapse>
                </b-col>
            </b-row>

            <b-row v-if="shipmentInfo.measures.length > 0">
                <b-col>
                    <b-collapse id="measures" class="mt-2">
                        <informationMeasure :title="$t('history.label.Measures')"
                                            :measures="filteredMeasures"
                                            :collis="shipmentInfo.listOfColli"></informationMeasure>
                    </b-collapse>
                </b-col>
            </b-row>
        </form>
    </b-modal>
</template>
<script>
    import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
    import helpers from '@/helper';
    import informationAddress from '../Actions/InformationAction/informationAddress';
    import informationDetails from '../Actions/InformationAction/informationDetails';
    import informationColli from '../Actions/InformationAction/informationColli';
    import informationCommodities from '../Actions/InformationAction/informationCommodities';
    import informationAes from '../Actions/InformationAction/informationAES';
    import informationPrice from '../Actions/InformationAction/informationPrice';
    import informationDocuments from '../Actions/InformationAction/informationDocuments';
    import informationDangerousGoods from '../Actions/InformationAction/informationDangerousGoods';
    import informationMeasure from '../Actions/InformationAction/informationMeasure';
    import viewOptions from '@/mixins/viewOptionsMixin';
    import { mapGetters } from 'vuex';
    import {BOOKING_TYPES, FIELD_NAMES as fieldNames} from "@/store/nameConstants";

    export default {
        props: {
            shipment: { type: Object, required: true },
        },

        mixins: [viewOptions],

        components: {
            informationAddress,
            informationDetails,
            informationColli,
            informationCommodities,
            informationAes,
            informationPrice,
            informationDocuments,
            informationDangerousGoods,
            informationMeasure,
        },

        data() {
            return {
                shipmentInfo: null,
            };
        },

        computed: {
          fieldNames() {
            return fieldNames
          },
            BOOKING_TYPES() {
                return BOOKING_TYPES
            },
            ...mapGetters('core', ['isCustomer', 'isAdminOrSuperUser']),
            filteredMeasures() {
                return this.shipmentInfo.measures.filter(measure => measure.measureCode === 'S' || measure.measureCode === 'M');
            },
        },
        methods: {
            async showInformationModal() {
                const response = await this.$store.dispatch(
                    HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_HISTORY_SHIPMENT_INFO,
                    this.shipment.id
                );

                this.shipmentInfo = response;

                this.$refs['information-modal'].show();
            },
        },
    };
</script>

<style>
    .contact {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 14px;
        padding-right: 14px;
    }
</style>
